import { useEffect } from "react";

/**
 * Hook for form field warnings on mount
 */
export const useFormFieldWarnings = (
    id: string | undefined,
    name: string | undefined,
): void => {
    useEffect(() => {
        if (!id) {
            console.warn(
                "Form Field mounted without an `id` property. This is bad for accessibility.",
            );
        }
        if (!name) {
            console.warn(
                "Form Field mounted without a `name` property. This is bad for accessibility.",
            );
        }
    }, [id, name]);
};
